export default "__VITE_ASSET__d881bbbf__"